import { useEffect } from 'react';
import GUI from './Gui/components/GUI';
import { loadGrid, LoadingStatus, setLoadingStatus, useLoadingStore } from './store/LoadingStore';
import useViewerStore from './store/viewerStore';
import Auth from './Gui/Auth';
import useNotificationStore from '@gui/store/notification';
import { NotificationType } from '@visualizer/types';
import useMemoryWatchdog from './hooks/useMemoryWatchdog';
import SentryErrorBoundary from './Gui/components/SentryErrorBoundary';
import { useAutoSaveState } from './Gui/components/panels/settings/SettingsMenu';
import { useErrorScreenStore } from './Gui/store/errorScreenStore';

export default function App() {
    const viewer = useViewerStore((state) => state.viewer);
    const ensureViewer = useViewerStore((state) => state.ensureViewer);
    const loadingStatus = useLoadingStore((state) => state.loadingStatus);
    const isErrorScreenVisible = useErrorScreenStore((state) => state.isErrorScreenVisible);
    useMemoryWatchdog();
    useAutoSaveState({ enabled: loadingStatus !== LoadingStatus.ERROR && !isErrorScreenVisible });

    useEffect(() => {
        ensureViewer();
    }, [ensureViewer]);

    useEffect(() => {
        if (!viewer) return;

        let disposed = false;

        loadGrid()
            .then((loaded) => {
                if (disposed) return;
                if (!loaded) return;
                return viewer.initialize();
            })
            .catch((error) => {
                console.error('Failed to load grid:', error);
                useNotificationStore.getState().showNotification('Failed to load grid data', NotificationType.Error);
                setLoadingStatus(LoadingStatus.ERROR);
            });

        return () => {
            disposed = true;
            viewer.done();
        };
    }, [viewer]);

    if (!viewer) {
        return null;
    }

    return (
        <SentryErrorBoundary>
            {/* { <canvas />} */}
            <div id="canvas-container">
                <Auth>
                    <GUI viewer={viewer} />
                </Auth>
            </div>
        </SentryErrorBoundary>
    );
}
